module.exports = __webpack_public_path__ + "static/img/item-l_c_pineapple.36db345.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/item-l_c_pineapple.png
// module id = vjO/
// module chunks = 1